import { createClient } from '@supabase/supabase-js';

// ------------------------------------------------------------------
// REPLACE THESE VALUES WITH YOUR PROJECT DETAILS FROM SUPABASE
// Go to Supabase Dashboard -> Project Settings -> API
// ------------------------------------------------------------------
const SUPABASE_URL = 'https://msrulycvsdjdmeodepll.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1zcnVseWN2c2RqZG1lb2RlcGxsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU1MTAxNzYsImV4cCI6MjA4MTA4NjE3Nn0.7rrAsuZI--Q5ofulQJNkNmEkOU64nJ1STIIoEZMXtwM';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);